module.exports = __webpack_public_path__ + "images/emoji/slot_machine.0d0c8908bb68d8683599.png";